@if(component){
<div class="pos-relative">
    @if(component.slides.length > 1 && component?.showArrows){
    <div *ifSize="'XL'"
         class="flex flex-justify-end pos-absolute bottom-4 _right z-5">
        <!-- navigation -->
        <div class="right">
            <button class="m-r-3 swiper-top-arrow-button"
                    [ngClass]="'cms-banner-prev-' + uid"
                    aria-label="Previous slide">
                <i class="icon-chevron-left  inline-flex col-w"
                   aria-hidden="true"></i>
            </button>
            <button class="swiper-top-arrow-button"
                    [ngClass]="'cms-banner-next-' + uid"
                    aria-label="Next slide">
                <i class="icon-chevron-right inline-flex col-w"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>
    }

    <carousel class="default-swiper swiper-slide-per-view"
              [class.is-empty]="!component.slides.length"
              [loop]="component?.loop"
              [autoplay]="component?.autoplay ? { delay: component?.interval} : false"
              [pagination]="{clickable: true}"
              [navigation]="{
                        nextEl: '.cms-banner-next-' + uid,
                        prevEl: '.cms-banner-prev-' + uid
                    }"
              #carouselRef>
        @for (slide of component.slides; track slide; let i = $index) {
        <ng-template carouselSlide>
            <div [ngClass]="component?.ratio || ''">
                <cms-hero-banner [component]="slide"></cms-hero-banner>
            </div>
        </ng-template>
        }
    </carousel>
</div>
}